import { DeleteOutlined } from '@ant-design/icons';
import { Col, Row, Button } from 'antd';
import styled from 'styled-components';

export const Title = styled.h1`
	font-size: 25px;
	font-weight: 600;
	color: #262626;
`;

export const Container = styled.div`
	background: #ffffff;
	border: 1px solid #e5e5e5;
	border-radius: 8px;
	padding: 12px 8px;
	width: 100%;
	margin-bottom: 8px;

	&:hover {
		background: #f8f9fa;
		border-color: #d0d7de;
	}

	.ant-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
`;

export const Section = styled.div`
	flex: 1;
	text-align: center;
	font-size: 14px;
	font-weight: 400;
	color: #222;
`;

export const Divider = styled.div`
	width: 1px;
	height: 24px;
	background: #e5e5e5;
	margin: 0 8px;
	flex-shrink: 0;

	@media (max-width: 576px) {
		display: none;
	}
`;

export const DeleteButton = styled(DeleteOutlined)`
	color: #d13342;
	font-size: 15px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		color: #a10e1e;
	}
`;

export const CustomCol = styled(Col)`
	display: flex;
	-webkit-box-align: center;
	align-items: center;
	justify-content: center;
`;

export const CustomRow = styled(Row)`
	display: flex !important;
	align-items: center !important;
	justify-content: space-evenly !important;
	width: 100%;

	&.ant-row {
		display: flex !important;
		align-items: center !important;
		justify-content: space-evenly !important;
	}
`;

export const DeleteOutlinedBig = styled(DeleteOutlined)`
	font-size: 48px;
	color: #d13342;
	margin-top: 16px;
`;

export const ConfirmButton = styled(Button)`
	font-size: 0.875rem;

	max-height: 2rem;
	border-radius: 4px;
	background-color: #2f54eb;
	border: 1px solid #2f54eb;
	box-shadow: 0px 2px 0px 0px #0000000b;
`;

export const CancelButton = styled(Button)`
	font-size: 0.875rem;
	min-height: 2rem;
	border-radius: 4px;
	border: 1px solid #e6e6e6;
	box-shadow: 0px 1px 0px 0px #0000000b;
`;
